import { Slider, SliderProps } from '@mui/material'

type Props = SliderProps & {
  darkTheme?: boolean
  className?: string
}

export const StyledSlider = ({
  darkTheme,
  className = '',
  disabled,
  ...sliderProps
}: Props) => {
  return (
    <Slider
      disabled={disabled}
      className={className}
      sx={{
        height: '10px !important',
        color: darkTheme ? '#88898D !important' : '#E3E3E3 !important',
        '& .MuiSlider-rail': {
          backgroundColor: darkTheme
            ? '#CACED4 !important'
            : '#E3E3E3 !important',
        },
        '& .MuiSlider-track': {
          border: 'none',
        },
        '& .MuiSlider-thumb': {
          height: '18px !important',
          width: '34px !important',
          borderRadius: '9px',
          backgroundColor: darkTheme
            ? '#353538 !important'
            : '#F5F5F5 !important',
          '&::before': {
            display: 'none',
          },
        },
      }}
      {...sliderProps}
    />
  )
}
